export function statusTracker() {
  var parentObj = this["mgr"];
  var readyState = this.readyState;
  if (readyState == 4) {
    var status = this.status;
    if (status < 400) {
      try {
        parentObj.TransactionComplete();
      } catch (err) {
        console.error(err);
        parentObj.TransactionFailed(this.fCallBackObj);
      }
    } else if (status < 500) {
      parentObj.SessionEnded(this.fCallBackObj);
      //TODO: Explicit handling of 300 range out here? Or leave it within the complete calls?
    } else {
      parentObj.TransactionFailed(this.fCallBackObj);
    }
  }
}
